import {useCallback, useEffect, useState} from 'react';
import {addLifecycleEntry, subscribeToLifecycle} from '../services/lifecycleApi';
import {useAsyncAction} from './useAsyncAction';

/**
 * Encapsulates lifecycle subscription and status updates.
 *
 * @param {string} edgeId
 */
export const useLifecycle = (edgeId) => {
  const {loading, error, run} = useAsyncAction();
  const [selectedLifecycle, setSelectedLifecycle] = useState('waiting');
  const [comment, setComment] = useState('');
  const [lifecycleHistory, setLifecycleHistory] = useState([]);

  useEffect(() => {
    if (!edgeId) return;
    const unsubscribe = subscribeToLifecycle(
      edgeId,
      (history) => {
        setLifecycleHistory(history);
        if (history.length > 0) {
          setSelectedLifecycle(history[0].status);
        }
      },
      (err) => console.error('Lifecycle listener failed:', err),
    );
    return () => unsubscribe();
  }, [edgeId]);

  const updateStatus = useCallback(async () => {
    if (!selectedLifecycle) return;
    const result = await run(
      () => addLifecycleEntry(edgeId, selectedLifecycle, comment),
      'Unable to save lifecycle status.',
    );
    if (result.ok) setComment('');
  }, [edgeId, selectedLifecycle, comment, run]);

  return {
    loading,
    error,
    selectedLifecycle,
    setSelectedLifecycle,
    comment,
    setComment,
    lifecycleHistory,
    updateStatus,
  };
};

